import { LoginUserStates } from '../types';
import { IConfiguredHttp } from './http';

export interface ILoginInformation {
	loginEmail: string;
	passwordless: boolean;
	enabled?: boolean;
	status: keyof typeof LoginUserStates | undefined;
}

export interface IAdminLoginApi {
	getUserLoginInformation: (customerId: string) => Promise<ILoginInformation>;
	updateUserLoginInformation: (customerId: string, loginInformation: ILoginInformation) => Promise<ILoginInformation>;
	disableUserAccount: (customerId: string) => Promise<ILoginInformation>;
}

const adminLoginApiFactory = (http: IConfiguredHttp, prefix = '/client'): IAdminLoginApi => ({
	getUserLoginInformation(customerId: string) {
		return http.get(`${prefix}/auth/login/${customerId}`);
	},
	updateUserLoginInformation(customerId: string, loginInformation: ILoginInformation) {
		return http.put(`${prefix}/auth/login/${customerId}`, loginInformation);
	},
	disableUserAccount(customerId: string) {
		return http.put(`${prefix}/auth/login/disable/${customerId}`);
	}
});

export default adminLoginApiFactory;
